"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 45px;\n  left: 25px;\n  width: 0px;\n  height: 0px;\n  border-right: 12px solid transparent;\n  border-top: 12px solid ", " ;\n  border-left: 12px solid ", " ;\n  border-bottom: 12px solid ", " ;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin: 75px;\n  display: inline-block;\n  vertical-align: middle;\n  border: 8px dotted ", " ;\n  transition: all 1s ease;\n  animation: ", " ", "s linear infinite;\n  border-bottom-width: 1px;\n  border-bottom-color: ", " ;\n  border-left-width: 2px;\n  border-left-color:  ", " ;\n  border-top-width: 3px;\n  border-right-width: 4px;\n  border-top-color:  ", " ;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n 0% {\n transform: rotate(0deg);\n}\n 100% {\n transform: rotate(-360deg);\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var load = (0, _styledComponents.keyframes)(_templateObject());

var Container = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.color || '#00adb5';
}, load, function (props) {
  return props.speed || 1;
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.color || '#00adb5';
});

var ItemDiv = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.color || '#00adb5';
}, function (props) {
  return props.color || '#00adb5';
});

var EatLoading = function EatLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      speed = _ref.speed,
      color = _ref.color;
  return _react.default.createElement(Container, {
    style: style,
    speed: speed,
    color: color
  }, _react.default.createElement(ItemDiv, {
    color: color
  }));
};

var _default = EatLoading;
exports.default = _default;